// Keyboard access for clickable elements that aren't buttons (spans, divs styled as chips, rows and cards)

/**
 * props that make an element work as a button: focusable, announced as a button, Enter and Space click it
 * @param onClick click handler; it gets the keyboard event for Enter/Space
 * @param extra more props (aria-pressed, title…)
 */
export function pressable(onClick, extra) {
  return {
    role: "button",
    tabIndex: 0,
    onClick,
    onKeyDown: (e) => {
      if (e.target !== e.currentTarget) return; // a key meant for a control inside
      if (e.key !== "Enter" && e.key !== " ") return;
      e.preventDefault();
      onClick(e);
    },
    ...extra,
  };
}
